// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___38jmw","wrapper":"wrapper___2fDXs","subtitle":"subtitle___Vx9dF","submit":"submit___1e_su"};